export default __webpack_public_path__ + "static/media/4.fa059b5d.png";